import * as React from 'react'
import './rc-slider.css';
import Slider from 'rc-slider/lib/Slider';
import style from './index.module.css'

interface IProps {
  currentTime: number
  totalTime: number
  onChange: (num: number) =>any
  onAfterChange: (num: number) =>any
}

function renderTime(time: number): string {
  const seconds = Math.round(time)
  const minute = Math.floor(seconds / 60)
  const remainderSeconds = seconds - (minute * 60)

  const secondsString
    = remainderSeconds < 10
    ? '0' + remainderSeconds
    : remainderSeconds

  return `${minute}:${secondsString}`
}



export function ProgressBar(props: IProps) {
  const scale =  props.totalTime / 100 // 默认100

  function onChange(num: number) {
    props.onChange(num * scale)
  }

  function onAfterChange(num: number) {
    props.onAfterChange(num * scale)
  }

  const currentTime = props.currentTime || 0
  const currentValue = currentTime / scale
  const totalTime = props.totalTime

  return (
   <div data-role="progress-bar" className={style.ProgressBar}>
      <div data-role="progress-left" className={style.ProgressBarCurrentTime}>{currentTime <= 0 ? '0:00':renderTime(currentTime)}</div>
      <Slider {...props} onChange={onChange} onAfterChange={onAfterChange} value={currentValue} />
      <div data-role="progress-right" className={style.ProgressBarTotalTime}>{totalTime === 0? '0:00' : renderTime(totalTime)}</div>
   </div>
  )
  
}


// WEBPACK FOOTER //
// ../src/progress-bar/index.tsx